import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { createToggleReducer } from 'modules/utils';
import {
  closeSaveModal,
  fetchTemplate,
  fetchTemplateFailure,
  fetchTemplateSuccess,
  openSaveModal,
  sendCustomize,
  sendCustomizeFailure,
  sendCustomizeSuccess,
  setSelectedTemplate,
  toggleEdit,
} from 'modules/entity/subEntities/customize/actions';

export const sendIsLoading = createToggleReducer(sendCustomize, sendCustomizeSuccess, sendCustomizeFailure);
export const templateIsLoading = createToggleReducer(fetchTemplate, fetchTemplateSuccess, fetchTemplateFailure);
export const templateIsSaveModalOpen = createToggleReducer(openSaveModal, closeSaveModal, sendCustomize);

export const templateIsEdit = createReducer(false, (builder) => {
  builder.addCase(toggleEdit, (state) => !state);
});

export const templateSelectedTemplate = createReducer(/** @type {string | null} */ (null), (builder) => {
  builder.addCase(setSelectedTemplate, (_, { payload }) => payload.id);
});

export default combineReducers({
  send: combineReducers({ isLoading: sendIsLoading }),
  template: combineReducers({
    isEdit: templateIsEdit,
    isLoading: templateIsLoading,
    isSaveModalOpen: templateIsSaveModalOpen,
    selectedTemplate: templateSelectedTemplate,
  }),
});
